import React, { useState, useEffect } from 'react';
import { getUserReportList, getUserReportDetail } from '../../services/apiService';
import './UserReportPage.css'; // Buat file CSS untuk styling
import UserDetailModal from './UserDetailModal'; // Komponen Modal yang akan kita buat

function UserReportPage() {
    const [users, setUsers] = useState([]);
    const [pagination, setPagination] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const fetchUsers = async (page = 1) => {
        setIsLoading(true);
        setError(null);
        try {
            const data = await getUserReportList(page);
            setUsers(data.data);
            setPagination({
                currentPage: data.current_page,
                lastPage: data.last_page,
                total: data.total,
            });
        } catch (err) {
            setError(err.message || 'Gagal memuat data report.');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers(1);
    }, []);

    const handleDetailClick = async (userId) => {
        try {
            const result = await getUserReportDetail(userId);
            setSelectedUser(result.data);
            setIsModalOpen(true);
        } catch (err) {
            alert('Gagal memuat detail user: ' + err.message);
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.lastPage) {
            fetchUsers(newPage);
        }
    };

    if (isLoading && !users.length) {
        return <div>Loading user reports...</div>;
    }

    if (error) {
        return <div className="error-message">Error: {error}</div>;
    }

    return (
        <div className="report-page">
            <h2>Laporan Pengguna</h2>
            <table className="report-table">
                <thead>
                    <tr>
                        <th>Nama</th>
                        <th>Nomor Telepon</th>
                        <th>Poin Saat Ini</th>
                        <th>Aksi</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(user => (
                        <tr key={user.id}>
                            <td>{user.name}</td>
                            <td>{user.phone_number}</td>
                            <td>{user.total_points}</td>
                            <td>
                                <button onClick={() => handleDetailClick(user.id)}>Detail</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            
            {/* Pagination Controls */}
            {pagination && (
                <div className="pagination">
                    <button onClick={() => handlePageChange(pagination.currentPage - 1)} disabled={pagination.currentPage === 1}>
                        Previous
                    </button>
                    <span>Page {pagination.currentPage} of {pagination.lastPage}</span>
                    <button onClick={() => handlePageChange(pagination.currentPage + 1)} disabled={pagination.currentPage === pagination.lastPage}>
                        Next
                    </button>
                </div>
            )}
            
            {/* Modal untuk Detail User */}
            {isModalOpen && (
                <UserDetailModal user={selectedUser} onClose={() => setIsModalOpen(false)} />
            )}
        </div>
    );
}

export default UserReportPage;